import { Nav } from "react-bootstrap";

import "./linkButtonStyles.css";

const LinkButton = ({ text, link, newTab = false }) => {
  return (
    <Nav.Link
      href={link}
      className="header-link"
      {...(newTab && { target: "_blank", rel: "noopener" })}
    >
      <span>{text}</span>
    </Nav.Link>
  );
};

export default LinkButton;
